import { isNonEmpty } from "common/utils";
import CryptoJS from "crypto-js";

const ITEM_NAME = process.env['PUBLIC_URL'] + '/state';
const secretPass = process.env['REACT_APP_SECRET_KEY'] ?? '';

export const loadState = () => {

    if(isNonEmpty(localStorage.getItem(ITEM_NAME))){
        sessionStorage.setItem(ITEM_NAME,localStorage.getItem(ITEM_NAME)!);
    };

    const serializedState = sessionStorage.getItem(ITEM_NAME); 
    try {
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse((secretPass ? CryptoJS.AES.decrypt(serializedState, secretPass).toString(CryptoJS.enc.Utf8) : serializedState));
    } catch (err) {
        return undefined;
    }
  };

export const saveState = (state: any) => {
        
        
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem(ITEM_NAME, (secretPass ? CryptoJS.AES.encrypt(serializedState, secretPass).toString() : serializedState));
        localStorage.setItem(ITEM_NAME,sessionStorage.getItem(ITEM_NAME)!);
    } catch {
        // ignore write errors
    }
};

